import React, { useState, useEffect } from 'react';
import {
  Modal as YkbModal,
  Button,
  Form,
  TextInput,
  Spin,
  Card,
  Row,
  Col,
  Icon,
  styled,
  Typography,
  PhoneInput,
  Notification,
} from 'ykb-ui';
import image from '../../assets/form-images/phone.png';
import qrImage from '../../assets/form-images/qr.png';
import callApi from '../../utils/callApi';
import iosImage from '../../assets/apple-store-button.png';
import androidImage from '../../assets/android-store-button.png';

const Modal = styled(YkbModal)`
  margin-top: -100px;
  > div > div {
    padding: 0px;
    border-radius: 10px;
    overflow: hidden;
    max-height: fit-content !important;
  }

  > div > button {
    z-index: 1;
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  left: 0px;
  right: 66%;
  top: 0px;
  bottom: 0px;
  background: red;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e9eaeb;
`;

const Image = styled.img`
  margin: 0 auto;
  max-width: 90%;
  position: relative;
  left: 5px;
`;

const ContentWrapper = styled.div`
  padding: 10px;
`;

const QrWrapper = styled.div`
  background: ${props => props.theme.color.primary6};
  border-radius: 10px;
  overflow: hidden;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: white;
`;

const AppDownloadButton = styled.a`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 5px;
  overflow: hidden;
  text-decoration: none;
`;
const ModalWithMargin = styled(Modal)`
  margin-top: -100px !important;
`;
const SmsTitle = styled(Typography.Title)`
  color: ${props => props.theme.color.primary6};
`;

export default function ESVInfoModal({ visible, handleVisible }) {
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const [loading, setLoading] = useState(false);

  const [refreshToken, setRefreshToken] = useState(0);

  useEffect(() => {}, []);

  function isMobile() {
    let check = false;
    (function(a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    console.log(window.innerWidth);
    return check;
  }

  const Title = styled(Typography.Title)`
    color: ${props => props.theme.color.primary6} !important;
    font-weight: 500 !important;
    margin-top: 10px !important;
    margin-bottom: 15px !important;
    line-height: 1 !important;
    @media (max-width: 767px) {
      line-height: 26px !important;
      font-size: 20px !important;
    }
  `;

  function refreshCaptcha() {
    setRefreshToken(refreshToken + 1);
  }
  function submitForm(e, error, values) {
    e.preventDefault();
    if (!error) {
      postSms(values);
    }
  }

  function handleModalClose() {
    handleVisible(false);
  }

  async function postSms(values) {
    try {
      setButtonDisabled(true);
      setLoading(true);
      const response = await callApi({
        endpoint: 'MobilApp/SendSmsDownload',
        method: 'POST',
        body: values,
      });
      if (response) {
        Notification.success(`SMS gönderildi.`);
      }

      handleModalClose();
    } catch (e) {
    } finally {
      refreshCaptcha();
      setLoading(false);
      setButtonDisabled(false);
    }
  }

  return (
    <Spin spinning={loading}>
      <ModalWithMargin
        onClose={handleModalClose}
        visible={true}
        title=""
        size="large"
      >
        <Row style={{ position: 'relative' }}>
          <Col
            xs={24}
            sm={8}
            md={8}
            lg={8}
            className="hidden-xs"
            style={{ position: 'static' }}
          >
            <ImageWrapper>
              <Image src={image} alt="Facebook Profilimiz" />
            </ImageWrapper>
          </Col>

          <Col xs={24} sm={16} md={16} lg={16}>
            <ContentWrapper>
              <Title>ESV Mobil Cepte</Title>
              <Card>
                <p>
                  <b>Yapı Kredi Emekli Sandığı Üyesi İseniz;</b>
                </p>
                <p>
                  ESV Mobil'i hemen indirip Tek Şifre'niz ile giriş yaparak ya
                  da yeni bir şifre oluşturarak anında kullanmaya
                  başlayabilirsiniz.
                </p>

                <p>
                  <b>Yapı Kredi Emekli Sandığı Üyesi Değilseniz;</b>
                </p>
                <p>
                  ESV Mobil'i indirip Üye Olun adımından üyelik işlemlerinizi
                  tamamlayarak kullanmaya başlayabilirsiniz.
                </p>
              </Card>
              <QrWrapper>
                {isMobile() ? (
                  <div>
                    <p>ESV Mobil uygulamasını indirin!</p>
                    <div>
                      <AppDownloadButton
                        href="https://apps.apple.com/tr/app/esv-mobil/id1609917748"
                        target="_blank"
                      >
                        <div>
                          <img src={iosImage} alt="App Store" />
                        </div>
                      </AppDownloadButton>
                      <AppDownloadButton
                        href="https://play.google.com/store/apps/details?id=com.ykb.esv"
                        target="_blank"
                      >
                        <div>
                          <img src={androidImage} alt="Google Play" />
                        </div>

                        {/* <div>
                          <img src="http://via.placeholder.com/30x30" />
                        </div>
                        <div>
                          <div>Google Play'den</div>
                          <div>Alın</div>
                        </div> */}
                      </AppDownloadButton>
                    </div>
                  </div>
                ) : (
                  <div>
                    <Row>
                      <Col sm={6}>
                        <img src={qrImage} alt="Facebook Profilimiz" />
                      </Col>
                      <Col sm={18}>
                        <p>
                          <b>QR Kod İle İndir</b>
                        </p>
                        <p>
                          QR kodu okutarak cihazınıza uygun ESV Mobil
                          uygulamasını indirin!
                        </p>
                      </Col>
                    </Row>
                  </div>
                )}
              </QrWrapper>
              <div>
                <SmsTitle level={4}> Sms Linki İle İndir</SmsTitle>
                <Form
                  // ref={formRef}
                  colSpan={{ xs: 24, md: 24 }}
                  onSubmit={submitForm}
                >
                  <Form.Item>
                    <Row>
                      <Col
                        sm={24}
                        md={24}
                        lg={9}
                        style={{
                          paddingLeft: '0px',
                          paddingRight: '0px',
                        }}
                      >
                        <Form.Item label="Cep Telefonu Numarası">
                          <PhoneInput
                            style={
                              window.innerWidth > 769 ? { marginTop: -20 } : {}
                            }
                            name="phone"
                            validation={[{ required: true }]}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        sm={12}
                        md={12}
                        lg={6}
                        style={{
                          paddingLeft: '0px',
                          paddingRight: '0px',
                        }}
                      >
                        <Form.Item label={'Güvenlik Kodu'}>
                          <TextInput
                            style={
                              window.innerWidth > 769 ? { marginTop: -20 } : {}
                            }
                            name="captchaId"
                            validation={[{ required: true }]}
                            validationOptions={{
                              validateTrigger: ['onSubmit', 'onBlur'],
                            }}
                            autoComplete="off"
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        sm={12}
                        md={12}
                        lg={9}
                        style={{
                          paddingLeft: '0px',
                          paddingRight: '0px',
                          overflow: 'hidden',
                        }}
                      >
                        <Form.Item label={''}>
                          <img
                            alt="captcha"
                            src={`${process.env.REACT_APP_API}/MobilApp/GetCaptchaImage?${refreshToken}`}
                            style={
                              window.innerWidth > 769
                                ? { height: 40, float: 'left', marginTop: 3 }
                                : { height: 40, float: 'left' }
                            }
                          />
                          <Button
                            onClick={refreshCaptcha}
                            className="rightFloated"
                            style={
                              window.innerWidth > 769
                                ? { float: 'left', marginTop: 3 }
                                : { float: 'left' }
                            }
                          >
                            <Icon name="refresh" />
                          </Button>
                        </Form.Item>
                      </Col>
                      <Col md={24}>
                        <div>
                          <Form.Item>
                            *SMS Gönderimi Ücretsizdir.
                            <Button
                              disabled={buttonDisabled}
                              type="primary"
                              htmlType="submit"
                              className="rightFloated"
                              style={{ marginTop: '10px', float: 'right' }}
                            >
                              SMS Gönder
                            </Button>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </Form.Item>
                </Form>
              </div>
            </ContentWrapper>
          </Col>
        </Row>
      </ModalWithMargin>
    </Spin>
  );
}
